import { FC, PropsWithChildren } from 'react';

import { usePopoverContext, useTabsContext } from '@bonusly/design-system';

import { DropdownOption } from '../dropdown';
import { useHighlightTabOptionContext } from './context';

type HighlightTabOptionProps = PropsWithChildren;

export const HighlightTabOption: FC<HighlightTabOptionProps> = ({ children, ...rest }) => {
	const { index } = useHighlightTabOptionContext();
	const { onClose } = usePopoverContext();
	const { setSelectedIndex } = useTabsContext();

	const handleClick = () => {
		setSelectedIndex(index);
		onClose();
	};

	return (
		<DropdownOption onClick={handleClick} w="full" {...rest}>
			{children}
		</DropdownOption>
	);
};
